import { api } from './api';
import type { NicheInfo, NicheContentInfo } from '../types';

export const nichesApi = {
  list: (lang?: string) => {
    const qs = lang ? `?lang=${lang}` : '';
    return api.get<NicheInfo[]>(`/niches${qs}`);
  },
  listContent: (lang?: string) => {
    const qs = lang ? `?lang=${lang}` : '';
    return api.get<NicheContentInfo[]>(`/niches/content${qs}`);
  },
  rename: (name: string, newName: string) =>
    api.patch(`/niches/${encodeURIComponent(name)}`, { new_name: newName }),
};
